import { useEffect } from "react";

const useAutoLogoutOnDateChange = () => {
  useEffect(() => {
    // current local date (YYYY-MM-DD based on PC time)
    const today = new Date().toLocaleDateString("en-CA");
    const storedLoginDate = localStorage.getItem("loginDate");
    const isLoginEnabled = JSON.parse(localStorage.getItem("isLoginEnabled") || "false");

    // 🚪 condition 1: if isLoginEnabled is true but no loginDate → clear everything
    if (isLoginEnabled && !storedLoginDate) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.reload();
      return;
    }

    // 🚪 condition 2: if loginDate exists but is not today's date → clear everything
    if (storedLoginDate && storedLoginDate !== today) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.reload();
      return;
    }

    // ✅ otherwise, store today's date
    localStorage.setItem("loginDate", today);
  }, []);
};

export default useAutoLogoutOnDateChange;
